import { IIdentify } from 'src/app/models/identify.interface';

export interface IIdentifyState {
    identify: IIdentify;
}

export const initialIdentifyState: IIdentifyState = {
    identify: null
};
